const UNICODE_NON_BREAKING_SPACE = String.fromCharCode(160);
const USUAL_SPACE = String.fromCharCode(32);

export function formatMoney(value: number) {
  const amount = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency',
  });

  return amount.format(value).replace(UNICODE_NON_BREAKING_SPACE, USUAL_SPACE);
}
